import { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import AppliedForJobListComponent from "./AppliedForJobListComponent";
import SharedJobListComponent from "./SharedJobsListComponent";

const ManageJobList = () => {
  const navigate = useNavigate();
  const { tab } = useParams();

  const tabNames = {
    "applied-jobs": " Applied Jobs",
    agreements: "Agreements",
    "my-shortlist": "My Shortlist",
  };

  const tabComponents = {
    "applied-jobs": <AppliedForJobListComponent />,
    "my-shortlist": <SharedJobListComponent />,
  };

  const [activeTab, setActiveTab] = useState(tab || "applied-jobs");

  useEffect(() => {
    setActiveTab(tab || "applied-jobs");
  }, [tab]);

  const handleTabClick = (key) => {
    navigate(`/account/ps-dashboard/my-applications/${key}`);
    setActiveTab(key);
  };

  return (
    <div className="post-jobs-container">
      <div className="post-jobs-tabs">
        <div className="tabs-group">
          <div className="tabs">
            {Object.entries(tabComponents).map(([key, component]) => (
              <div
                key={key}
                className={`tab ${activeTab === key ? "active" : ""}`}
                onClick={() => handleTabClick(key)}
              >
                {tabNames[key]}
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="post-job-tab-content">{tabComponents[activeTab]}</div>
    </div>
  );
};

export default ManageJobList;
